

import React, { useEffect, useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
  const [inputPage, setInputPage] = useState("1");

  const handlePageChange = (value) => {
    console.log("currentPage",totalPages);
    const nextPage = Math.min(Math.max(value, 1), totalPages);
    setInputPage(nextPage.toString());
    onPageChange(nextPage);
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    setInputPage(value);
  };
  const handleInputKeyDown = (event) => {
    if (event.key === "Enter") {
      let pageNumber = parseInt(inputPage);
      if (isNaN(pageNumber) || pageNumber < 1 || pageNumber > totalPages) {
        pageNumber = 1;
        setInputPage("1");
      }
      onPageChange(pageNumber);
    }
  };
  useEffect(() => {
    setInputPage(currentPage.toString());
  }, [currentPage]);

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <div
        // onClick={() => {
        //   handlePageChange(currentPage - 1);
        // }}
        // className="prevpage"
        // style={{
        //   cursor: currentPage === 1 ? "" : "pointer",
        //   opacity: currentPage === 1 ? 0.5 : 1,
        // }}
        onClick={() => {
          if (currentPage > 1) {
            handlePageChange(currentPage - 1);
          }
        }}
        className="prevpage"
        style={{
          cursor: currentPage === 1 || totalPages === 0 ? "not-allowed" : "pointer",
          opacity: currentPage === 1 || totalPages === 0 ? 0.5 : 1,
        }}
      >
        <ArrowBackIosIcon
          sx={{ color: "var(--color-primary)", padding: "3px" }}
        />
      </div>
      <input
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        value={inputPage}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyDown}
        style={{ width: "50px", textAlign: "center", margin: "0 5px" }}
      />
      <p style={{ margin: "0" }}>{`of ${totalPages}`}</p>&nbsp;
      <div
        className="nextpage"
        onClick={() => {
          if (currentPage < totalPages) {
            handlePageChange(currentPage + 1);
          }
        }}
        style={{
          cursor: currentPage === totalPages || totalPages === 0 ? "not-allowed" : "pointer",
          opacity: currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
        }}
        // onClick={() => {
        //   handlePageChange(currentPage + 1);
        // }}
        // style={{
        //   cursor: currentPage === totalPages ? "" : "pointer",
        //   opacity: currentPage === totalPages ? 0.5 : 1,
        // }}
      >
        <ArrowForwardIosIcon
          sx={{ color: "var(--color-primary)", padding: "3px" }}
        />
      </div>
    </div>
  );
};

export default CustomPagination;
